// @flow
export { default as MicroTrainings } from './MicroTrainings';
export { default as MicroTrainingsAddEdit } from './MicroTrainingsAddEdit';